import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class IsAuthenticated implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  async canActivate(): Promise<boolean> {
    console.log("await this.auth.isAuthenticated()", await this.auth.isAuthenticated());
    if (await this.auth.isAuthenticated()) {
      return true;
    }
    this.router.navigate(['/sign-in']);
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CheckUserIsAuthenticated implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    if (await this.auth.isAuthenticated()) {
      return true;
    }
    this.router.navigate(['/sign-in'], {
      queryParams : { callBackUrl : route.queryParams.callBackUrl }
    });
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class IsNotAuthenticated implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    
    if (route.url[0].path == 'auto-sign-in') {
      await this.auth.signOut();
    }

    if (!await this.auth.isAuthenticated()) {
      return true;
    }
    this.router.navigate(['/private']);
    return false;
  }
}
